var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20782_77692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 7.50033H16.6667C17.1088 7.50033 17.5327 7.67592 17.8453 7.98848C18.1578 8.30104 18.3334 8.72496 18.3334 9.16699V18.3337L15.0001 15.0003H10.0001C9.55805 15.0003 9.13413 14.8247 8.82157 14.5122C8.50901 14.1996 8.33341 13.7757 8.33341 13.3337V12.5003M11.6667 7.50033C11.6667 7.94235 11.4912 8.36628 11.1786 8.67884C10.866 8.9914 10.4421 9.16699 10.0001 9.16699H5.00008L1.66675 12.5003V3.33366C1.66675 2.89163 1.84234 2.46771 2.1549 2.15515C2.46746 1.84259 2.89139 1.66699 3.33341 1.66699H10.0001C10.4421 1.66699 10.866 1.84259 11.1786 2.15515C11.4912 2.46771 11.6667 2.89163 11.6667 3.33366V7.50033Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20782_77692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.deccd88895063e0c1c0e63dfae31f7c0.svg";
export { ForwardRef as ReactComponent };